import { from } from '@apollo/client';
import createHttpLink from './httpLink';
import createRefreshLink from './refreshLink';
import createRequestLink from './requestLink';
import onErrorLink from './onErrorLink';

export const createLink = () =>
  from([createRefreshLink(), createRequestLink(), onErrorLink, createHttpLink()]);
